<template>
	<el-dialog width="550px" :visible.sync="visible" title="服务费总额" :close-on-click-modal="false"
		:close-on-press-escape="false">
		<el-form :model="dataForm" style="padding-right: 50px;"  ref="dataForm"
			@keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
			<el-row class="el-form-item el-form-item--default" v-for="platBody in platBodyList" :key="platBody.id">
				<el-col class="el-form-item__label" :span="14" style="text-align: center;">{{platBody.bodyName}}
				</el-col>
				<el-col class="el-form-item__label" :span="6" style="text-align: center;">{{platBody.balance}}</el-col>
				<el-col class="el-form-item__label" :span="4" style="text-align: center;">
					<el-button type="text" size="small" @click="detailsHandle(platBody.id)">
						提现
					</el-button>
				</el-col>
			</el-row>
		</el-form>
		<template slot="footer">
			<el-button @click="visible = false">{{ $t('cancel') }}</el-button>
			<el-button type="primary" @click="visible = false">{{ $t('confirm') }}</el-button>
		</template>
		<detail  v-if="detailsVisible" ref="detail" @refreshDataList="getDataList"></detail>
	</el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import debounce from 'lodash/debounce'
import {
  isEmail,
  isMobile
} from '@/utils/validate'
import Detail from './plataccount-payfee-details'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      visible: false,
      detailsVisible: false,
      dataForm: {
      },
      platBodyList: {}
    }
  },
  components: {
    Detail
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.getPlatBodyList()
      })
    },
    // 获取我方主体列表
    getPlatBodyList () {
      this.$http
        .get('/sys/plat/body/list')
        .then(({
          data: res
        }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.platBodyList = res.data
        })
        .catch(() => {})
    },

    // 详情
    detailsHandle (id) {
      this.detailsVisible = true
      this.$refs['dataForm'].resetFields()
      this.$nextTick(() => {
        this.$refs.detail.dataForm.id = id
        this.$refs.detail.init()
        this.$refs.detail.visible = true
        this.refundVisible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
	.mod-sys__user {
		.dept-list {

			.el-input__inner,
			.el-input__suffix {
				cursor: pointer;
			}
		}

		.role-list {
			.el-select {
				width: 100%;
			}
		}
	}
</style>
